<template>
  <header class="bg-white border-b border-gray">
    <nav class="container px-20 h-full grid grid-cols-12 items-center">
      <div class="col-span-2">
        <slot name="logo"></slot>
      </div>
      <div class="col-span-8 lg:mr-36 xl:mr-0">
        <search-form class="ml-auto leading-none px-14"
          placeholder="Type your search"
          @toggled="redirect"
          :default-value.sync="searchValue"
          inputClass="rounded-md py-16 text-14 focus:outline-none">
          <template #icon="{ term }">
            <div class="absolute right-0 center-y mr-12 cursor-pointer">
              <div class="px-10 py-8 text-dark-gray bg-white"
                @click="redirect({ term: term })">
                <i class="far fa-search text-lg"></i>
              </div>
            </div>
          </template>
        </search-form>
      </div>
      <div class="col-span-2 flex items-center justify-end gap-6 xl:gap-20 navbar-menu">
        <slot name="icons"></slot>
      </div>
    </nav>
    <div class="border-t border-b border-gray flex bg-white py-8">
      <ul class="h-full flex mx-auto gap-20 font-bold">
        <the-nav-bar-desktop-item
          v-for="item in menuItems"
          :key="item.id"
          :item="item"
        ></the-nav-bar-desktop-item>
      </ul>
    </div>
  </header>
</template>
<script>
import TheNavbarSearchResult from "../../Modules/Search/TheNavbarSearchResult.vue";
import TheNavBarDesktopItem from "./TheNavBarDesktopItem.vue";
import SearchForm from "../../Universal/SearchForm.vue";

export default {
  components: {
    TheNavbarSearchResult,
    TheNavBarDesktopItem,
    SearchForm,
  },

  props: {
    menu: Object,
  },

  data () {
    return {
      searchValue: new URLSearchParams(window.location.search).get("search")
    }
  },

  computed: {
    menuItems() {
      return this.menu.menuItems.filter((item) => item.enabled);
    },
  },

  created() {
    window.TheNavBarDesktop = this;
  },

  methods: {
    redirect(search) {
      if (search.term == null || search.term === "") {
        window.location.assign("/artworks");
      }

      if (search.term != null && search.term !== "") {
        window.location.assign(`/artworks?search=${search.term}`);
      }
    },

    clearSearch () {
      this.searchValue = null
    }
  },
};
</script>

<style>
@media screen and (max-width: 1439px) {
  .navbar-menu {
    margin-right: 30px;
  }
}
@media screen and (max-width: 1124px) {
  .navbar-menu {
    margin-right: 20px;
  }
}
@media screen and (max-width: 1024px) {
  .navbar-menu {
    margin-right: 10px;
  }
}
</style>
